import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ErrorMode } from '@/models';

@Component({
  name: 'CmgInput',
})
export default class CmgInput extends Vue {
  passwordVisible = false;
  passwordText = 'Password not visible';
  
  @Prop({ required: true })
  value!: string | boolean;

  @Prop({ required: false, default: 'text', type: String })
  type!: string;

  @Prop({ required: false, type: String })
  placeholder?: string;

  @Prop({ required: false, type: String })
  name?: string;

  @Prop({ required: false, default: false, type: Boolean })
  fat!: boolean;

  // This property lets the component know if has to add a
  // bottom margin for the absolutely positioned error messages
  @Prop({ required: false, default: false, type: Boolean })
  includeErrorLabel!: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  forceFocus!: boolean;

  // Why is 2^19 the HTML default? I have no idea
  @Prop({ required: false, default: 524288, type: Number })
  maxLength?: number;

  @Prop({ required: false, type: Boolean })
  maxLengthVisible?: boolean;

  @Prop({ required: false, default: '', type: String })
  errorMessage?: string;

  @Prop({ required: false, default: '', type: String })
  pattern?: string;

  @Prop({ required: false, type: String })
  autocomplete?: string;

  @Prop({ required: false, default: ErrorMode.PlaceHolder, type: String })
  errorMode!: ErrorMode;

  /** Currently only supported for inputs, not for checkboxes */
  @Prop({ required: false, default: false, type: Boolean })
  disabled!: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  readonly!: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  optional?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  required!: boolean;

  @Prop({ required: false, default: '', type: String  })
  ariaLabel!: string;

  @Prop({ required: false, default: '', type: String  })
  ariaChecked!: string;
  
  @Prop({ required: false, default: '', type: String  })
  role!: string;

  @Prop({ required: false, default: '', type: String  })
  ariaControls!: string;

  @Prop({ required: false, default: '', type: String  })
  ariaActivedescendant!: string;

  @Prop({ required: false, default: false, type: Boolean })
  ariarequired!: boolean;

  @Prop({ required: false, default: true, type: Boolean})
  shouldMaskUserInput?: boolean;
  
  get checkboxUncheckedImageUrl(): string {
    return this.$appStore.state.cms.images.icons.checkboxUnchecked.default;
  }

  get checkboxCheckedImageUrl(): string {
    return this.$appStore.state.cms.images.icons.checkboxChecked.default;
  }

  get passwordVisibilityImageUrl(): string {
    const icons = this.$appStore.state.cms.images.icons;
    const image = this.passwordVisible ? icons.passwordVisibilityHidden : icons.passwordVisibilityVisible;

    return image.default;
  }

  get passwordInputType(): 'text' | 'password' {
    return this.passwordVisible ? 'text' : 'password';
  }

  get placeholderText(): string {
    if (this.errorMode != ErrorMode.PlaceHolder) {
      return this.placeholder || '';
    }

    return this.errorMessage || this.placeholder || '';
  }

  get listeners() {
    return {
      ...this.$listeners,
      keyup: (e: any) => this.onKeyup(e),
      input: (e: any) => this.onTextValueChange(e),
    };
  }

  get charactersLeft(): number | null {
    if (typeof this.value !== 'string' || this.maxLength === undefined) {
      return null;
    }

    return this.maxLength - this.value.length;
  }

  get sanitizedValue(): string {
    if (typeof this.value != 'string') {
      return '';
    }

    return this.value;
  }

  mounted() {
    if (!this.forceFocus) {
      return;
    }

    const input = this.type == 'password' ? this.$refs.passwordInput : this.$refs.cmgInput;

    (input as HTMLInputElement).focus();
  }

  onClickCheckboxInput() {
    if (this.disabled) {
      return;
    }

    this.$emit('input', !this.value);
  }

  onTextValueChange(event: { target: { value: string } }) {
    //enforce the max length on emit
    this.$emit('input', event.target.value.substring(0, this.maxLength));
  }

  onKeyup(event: { keyCode: number }) {
    switch (event.keyCode) {
      case 13:
        this.$emit('submit', event);
        break;
      default:
        this.$emit('keyup', event);
    }
  }

  // input.maxlength is ignored on some mobile devices so we have this brute force method.
  forceMaxLength() {
    if(typeof this.value == 'string' && this.value.length > this.maxLength!) {
      this.value = this.value.substring(0, this.maxLength);
    }
  }

  togglePasswordInputType() {
    this.passwordVisible = !this.passwordVisible;
    if(this.passwordVisible){
    this.passwordText = 'Password Visible';
    }
    else{
      this.passwordText = 'Password not visible';
    }
  }
}
